<template>
  <ActionForm
    class="change-auth0-associated-membership"
    title="Change Auth0 Associated Membership"
    description="Use this component if you want to change the membership associated with the customers online profile"
    submit-label="Change Membership"
    icon="mdi-card-account-details-outline"
    :loading="loading"
    :status="status"
    :message="resp"
    success-message="User updated successfully"
    @submit="callapi"
  >
    <v-col cols="12" md="6">
      <v-text-field
        v-model="username"
        :rules="emailRules"
        label="Current Username"
        prepend-inner-icon="mdi-at"
      ></v-text-field>
    </v-col>

    <v-col cols="12" md="6">
      <v-text-field
        v-model="newMembershipNumber"
        :rules="membershipNumberRules"
        label="New Membership Number"
        prepend-inner-icon="mdi-pound"
        inputmode="numeric"
      ></v-text-field>
    </v-col>
  </ActionForm>
</template>

<script>
import api, { apiErrorMessage } from "../services/api";
import { emailRules, membershipNumberRules, normalizeEmail } from "../utils/validators";
import ActionForm from "./ActionForm.vue";

export default {
  name: "ChangeAuth0AssociatedMembership",
  components: { ActionForm },
  data() {
    return {
      username: null,
      newMembershipNumber: null,
      resp: null,
      status: null,
      loading: false,
      emailRules,
      membershipNumberRules,
    };
  },
  methods: {
    // ActionForm validates before emitting, so this only runs on a valid form.
    async callapi() {
      this.status = null;
      this.resp = null;
      this.loading = true;
      const username = encodeURIComponent(normalizeEmail(this.username));
      const membershipNumber = encodeURIComponent(
        String(this.newMembershipNumber).trim()
      );
      try {
        const response = await api.post(
          `/auth0reassociation/${username}/${membershipNumber}`
        );
        this.status = response.status;
        this.resp = response.data;
      } catch (error) {
        this.status = error.response?.status ?? null;
        this.resp = apiErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
